__webpack_require__.p = "/Open-Exchange-Rates-API-React-Wrapper/";